/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductNamesRequest } from '../../models/product-names-request';
import { ProductNamesResponse } from '../../models/product-names-response';

export interface GetProductNames$Params {
      body?: ProductNamesRequest
}

export function getProductNames(http: HttpClient, rootUrl: string, params?: GetProductNames$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductNamesResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductNames.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductNamesResponse>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getProductNames.PATH = '/api/advancedsearch/getproductnames';
getProductNames.METHOD = 'post';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getProductNames.ROOTURL = '/portal';
